import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { AvatarInitialsComponent, RichTextDirective } from '@libs/ui-lib';

@Component({
  selector: 'lib-assistant-message-preview',
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent, AvatarInitialsComponent, RichTextDirective],
  templateUrl: './assistant-message-preview.component.html',
  styleUrl: './assistant-message-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantMessagePreviewComponent {
  public readonly senderFirstName = input.required<string>();
  public readonly senderLastName = input<string>();
  // Empty for a message that only carries a video.
  public readonly text = input<string>('');
  public readonly hasVideo = input(false);
  // Missing until the backend generates the thumbnail - a placeholder shows until then.
  public readonly videoThumbnailUrl = input<string>();
  public readonly previewClick = output<void>();
  public readonly closeClick = output<void>();

  protected readonly isExpanded = signal(false);

  protected onMouseEnter(): void {
    this.isExpanded.set(true);
  }

  protected onMouseLeave(): void {
    this.isExpanded.set(false);
  }

  protected onClick(): void {
    this.previewClick.emit();
  }

  protected onCloseClick(): void {
    this.closeClick.emit();
  }
}
